import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { notify } from 'reducers/NotifierReducer';

function NoPermissionRedirect({ message = 'You do not have permission to access this page.' }) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(notify(message, 'error'));
  }, [dispatch, message]);

  return <Redirect to="/" />;
}

export default NoPermissionRedirect;
